module.exports = __webpack_public_path__ + "img/crm04.545c15fd.jpg";